import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import {DiagramLayers} from '../../../../utils/network-diagram/network-diagram-constants';

@Injectable({
  providedIn: 'root'
})
export class NetworkLayersService {
  isOpen = false;

  selectedLayers: any = {
    topology: true,
    quality: false,
    quota: false,
    cac: false
  };

  getSelectedLayers(): any {
    return {...this.selectedLayers, isOpen: this.isOpen};
  }

  setSelectedLayers(layersToSetObject): void {
    this.isOpen = layersToSetObject.isOpen;

    DiagramLayers.forEach((layer) => {
      this.selectedLayers[layer] = (layersToSetObject[layer] !== undefined && layersToSetObject[layer] !== null) ?
          layersToSetObject[layer] : this.selectedLayers[layer];
    });
  }
}
